var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdentification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m466.125 421.625h-420.25c-25.295 0-45.875-20.58-45.875-45.875v-239.5c0-25.295 20.58-45.875 45.875-45.875h420.25c25.295 0 45.875 20.58 45.875 45.875v239.5c0 25.295-20.58 45.875-45.875 45.875z",
    fill: "#ffe796"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m466.125 90.375h-210.125v331.25h210.125c25.295 0 45.875-20.58 45.875-45.875v-239.5c0-25.295-20.58-45.875-45.875-45.875z",
    fill: "#ffcf7d"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m188.25 301.125h-120.5c-8.284 0-15-6.716-15-15 0-41.493 33.757-75.25 75.25-75.25s75.25 33.757 75.25 75.25c0 8.284-6.716 15-15 15z",
    fill: "#fe6a16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m188.25 361.375h-120.5c-8.284 0-15-6.716-15-15s6.716-15 15-15h120.5c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
    fill: "#1b3b6b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m444.25 210.75h-120.5c-8.284 0-15-6.716-15-15s6.716-15 15-15h120.5c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
    fill: "#12254c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m444.25 271h-120.5c-8.284 0-15-6.716-15-15s6.716-15 15-15h120.5c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
    fill: "#12254c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m444.25 331.25h-120.5c-8.284 0-15-6.716-15-15s6.716-15 15-15h120.5c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
    fill: "#12254c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m128 240.875c-24.882 0-45.125-20.243-45.125-45.125s20.243-45.125 45.125-45.125 45.125 20.243 45.125 45.125-20.243 45.125-45.125 45.125z",
    fill: "#ffcdbe"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentification);
export default __webpack_public_path__ + "static/media/identification.85ff1bf8.svg";
export { ForwardRef as ReactComponent };